import { useEffect, useState } from 'react';
import { getTopNavPaths, onNavUsageChange } from '../lib/navUsage';

/**
 * Returns the user's most-used sidebar destinations (by path), highest first.
 * Re-renders whenever a new visit is recorded. Empty for users with no
 * history, so the caller can hide the Quick Access zone entirely.
 */
export function useNavUsage(limit = 5): string[] {
  const [paths, setPaths] = useState<string[]>(() => getTopNavPaths(limit));

  useEffect(() => {
    const update = () => setPaths(getTopNavPaths(limit));
    update(); // resync on mount (e.g. after a route change remounts the sidebar)
    return onNavUsageChange(update);
  }, [limit]);

  return paths;
}
